// Simple Search Trigger
const searchTriggerText = document.querySelector(".navigation__search-trigger");
const searchContainer = document.querySelector(".navigation__search");

window.addEventListener("click", function(e){   
  if (searchTriggerText.contains(e.target)){
    searchContainer.classList.add("is-active");
  } else {
    searchContainer.classList.remove("is-active");
  }
});